<template>
    <div class="head-content">
        <div class="head-title">
            <div class="head-t">
                <h3 class="head-h3" style="margin-right: 15px;">系统发票单号：{{ infoData.sysInvoiceNo }}</h3>
                <el-tag size="medium" v-show="makeInvoiceStatusText" >{{ makeInvoiceStatusText }}</el-tag>
                <!-- <span class="head-r" v-show="makeInvoiceStatusText">{{ makeInvoiceStatusText }}</span> -->
            </div>
            <div class="head-right">
                <i class="el-icon-success" :style="{'color':editStatus === '0' ? '#67C23A':'#E6A23C'}">  {{ editStatusText }}</i>
            </div>
        </div>
        <el-row :gutter="20" :data="infoData">
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            结算申请单号：
                            <span
                                class="value"
                                :title="infoData.apApplyNo"
                            >{{infoData.apApplyNo}}</span>
                        </div>
                        <div class="label">
                            发票类型：
                            <el-select :disabled="disabled" style="width: calc(100% - 76px) ;" v-model="infoData.invoiceType" placeholder="请选择">
                                <el-option
                                    v-for="(item,index) in invoiceTypeOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                    :disabled="!(invoiceTypeAvailable.includes(`${item.value}`))"
                                ></el-option>
                            </el-select>
                        </div>
                        <div class="label">
                            原蓝票号：
                            <span
                                class="value"
                                :title="infoData.oldInvoiceNo"
                            >{{infoData.oldInvoiceNo}}</span>
                        </div>
                        <div class="label">
                            购买方名称：
                            <span
                                class="value"
                                :title="infoData.buyerName"
                            >{{infoData.buyerName}}</span>
                        </div>
                        <div class="label">
                            购买方详情：
                            <el-checkbox :disabled="disabled" :true-label="1" :false-label="0" v-model="infoData.ifShowBuyer">是否展示</el-checkbox>
                        </div>
                        <div class="label" v-show="infoData.ifShowBuyer === 1">
                            购买方地址：
                            <span class="value" :title="infoData.buyerAddress">{{infoData.buyerAddress}}</span>
                        </div>
                        <div class="label" v-show="infoData.ifShowBuyer === 1">
                            购买方开户银行：
                            <span class="value" :title="infoData.buyerBankName">{{infoData.buyerBankName}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            系统发票号：
                            <span
                                class="value"
                                :title="infoData.sysInvoiceNo"
                            >{{infoData.sysInvoiceNo}}</span>
                        </div>
                        <div class="label" >
                            价税合计金额：
                            <span
                                class="value"
                                :title="infoData.amt"
                            >{{infoData.amt}}</span>
                        </div>
                        <div class="label">
                            原结算申请单号：
                            <span class="value" :title="infoData.oldApplyNo">{{infoData.oldApplyNo}}</span>
                        </div>
                        <div class="label">
                            购买方纳税人识别号：
                            <span class="value" :title="infoData.buyerTaxNo">{{infoData.buyerTaxNo}}</span>
                        </div>
                        <div class="label">
                        </div>
                        <div class="label" v-show="infoData.ifShowBuyer === 1">
                            购买方电话：
                            <span class="value" :title="infoData.buyerPhone">{{infoData.buyerPhone}}</span>
                        </div>
                        <div class="label" v-show="infoData.ifShowBuyer === 1">
                            购买方银行账号：
                            <span class="value" :title="infoData.buyerBankAccount">{{infoData.buyerBankAccount}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            发票标签：
                            <el-select :disabled="disabled" style="width: 120px;" v-model="infoData.invoiceLabel" placeholder="请选择"  @change="invoiceLabelChange">
                                <el-option
                                    v-for="(item,index) in invoiceLabelOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                        <div class="label">
                            备注：
                            <el-input :disabled="disabled" :title="infoData.remark" style="width: 150px;" placeholder="请输入" v-model="infoData.remark" clearable></el-input>
                        </div>
                        <div style="width: 800px;" class="label">
                            开票失败原因：
                            <span
                                class="value"
                                :title="infoData.eiHandleResult"
                            >{{infoData.eiHandleResult}}</span>
                        </div>
                        <div class="label">
                            销售方名称：
                            <span
                                class="value"
                                :title="infoData.sellerName"
                            >{{infoData.sellerName}}</span>
                        </div>
                        <div class="label">
                            销售方详情：
                            <el-checkbox :disabled="disabled" :true-label="1" :false-label="0" v-model="infoData.ifShowSeller">是否展示</el-checkbox>
                        </div>
                        <div class="label" v-show="infoData.ifShowSeller === 1">
                            销售方地址：
                            <span class="value" :title="infoData.sellerAddress">{{infoData.sellerAddress}}</span>
                        </div>
                        <div class="label" v-show="infoData.ifShowSeller === 1">
                            销售方开户银行：
                            <span class="value" :title="infoData.sellerBankName">{{infoData.sellerBankName}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            开票方式：
                            <span class="value" :title="({'10':'按单位汇总','20':'按起始地、目的地、车牌号汇总'}[infoData.openInvoiceType] || '')">{{{'10':'按单位汇总','20':'按起始地、目的地、车牌号汇总'}[infoData.openInvoiceType] || '' }}</span>
                        </div>
                        <div class="label">
                            开票日期：
                            <span class="value" :title="infoData.makeInvoiceDate">{{infoData.makeInvoiceDate}}</span>
                        </div>
                        <div class="label">

                        </div>
                        <div class="label" style="width: 300px;">
                            销售方纳税人识别号：
                            <span class="value" :title="infoData.sellerTaxNo">{{infoData.sellerTaxNo}}</span>
                        </div>
                        <div class="label">
                        </div>
                        <div class="label" v-show="infoData.ifShowSeller === 1" style="width: 300px;">
                            销售方电话：
                            <span class="value" :title="infoData.sellerPhone">{{infoData.sellerPhone}}</span>
                        </div>
                        <div class="label" style="width: 300px;" v-show="infoData.ifShowSeller === 1">
                            销售银行账号：
                            <span class="value" :title="infoData.sellerBankAccount">{{infoData.sellerBankAccount}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            发票号码：
                            <span class="value" :title="infoData.invoiceNo">{{infoData.invoiceNo}}</span>
                        </div>
                        <div class="label">
                            收款人：
                            <el-input :disabled="disabled" :title="infoData.payee" style="width: 80px;" placeholder="请输入" v-model="infoData.payee" clearable></el-input>
                        </div>
                        <div class="label">

                        </div>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">

                        <div class="label">
                            开票状态：
                            <span class="value" :title="makeInvoiceStatusText">{{makeInvoiceStatusText}}</span>
                        </div>
                        <div class="label">
                            复核人：
                            <el-input :disabled="disabled" style="width: 100px;" placeholder="请输入" v-model="infoData.checker" clearable></el-input>
                        </div>
                        <div class="label">
                            <!-- 开票人：
                            <span class="value" :title="infoData.makeInvoiceOperator">{{infoData.makeInvoiceOperator}}</span> -->
                        </div>
                    </div>
                </el-col>
        </el-row>
    </div>
</template>

<script>
import { getDictAndOptions } from '@/modules/transport/bms/api/common.js';
import { getTextByDict } from '@/modules/transport/bms/utils/common.js';
import { stAi } from '@/modules/transport/bms/components/judge/bmsModular';
import { setEditRecord } from '../../../utils.js';
import { deleteInvoiceBody } from '@/modules/transport/bms/api/invoiceManageApi.js';
import _ from 'lodash';
const EDIT_STATUS = {
    '0': '已保存',
    '1': '有修改未保存',
    '2': '未保存'
};

export default {
    props: {
        invoiceHeaderData: {
            type: Object
        }
    },
    data() {
        return {
            infoData: {
                apApplyNo: '',
                invoiceType: '',
                oldInvoiceNo: '',
                buyerName: '',
                buyerAddress: '',
                buyerBankName: '',
                sysInvoiceNo: '',
                amt: '',
                oldApplyNo: '',
                buyerTaxNo: '',
                buyerPhone: '',
                buyerBankAccount: '',
                invoiceLabel: '',
                taxRate: '',
                eiHandleResult: '',
                sellerName: '',
                sellerAddress: '',
                sellerBankName: '',
                sellerTaxNo: '',
                sellerPhone: '',
                sellerBankAccount: '',
                makeInvoiceStatus: '',
                openInvoiceType: '',
                invoiceNo: '',
                fee: '',
                makeInvoiceDate: '',
                makeInvoiceOperator: '',
                ifShowBuyer: 0,
                ifShowSeller: 0,
                remark: '',
                payee: '',
                checker: ''
            },
            editStatus: '0',
            oldInvoiceLabel: '',
            snapshoot: null,
            invoiceLabelOptions: [],
            invoiceTypeOptions: [],
            invoiceTypeAvailable: ['15', '16', '17', '18'] // 允许选择全电专票或全电普票，其他发票类型置灰-BUG2024050713440
        };
    },
    inject: ['updateInvoice'],
    computed: {
        makeInvoiceStatusText: function () {
            return getTextByDict(sessionStorage.getItem('BMS_AP_OPEN_INVOICE_STATUS'), this.infoData.makeInvoiceStatus);
        },

        editStatusText: function () {
            return EDIT_STATUS[this.editStatus];
        },

        disabled: function () {
            // 单据状态为“新建”
            const usable = [10, '10'].includes(this.invoiceHeaderData.makeInvoiceStatus);
            return !usable;
        }
    },
    methods: {
        invoiceLabelChange() {
            if (!this.invoiceHeaderData.jobId) return this.$emit('invoiceLabelChange', this.infoData.invoiceLabel);
            this.$confirm('切换发票标签后系统将清空当前发票明细、内容、备注, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.cancelButtonLoading = true;
                        instance.confirmButtonText = '切换中...';
                        deleteInvoiceBody(this.invoiceHeaderData.jobId).then(async() => {
                            const invoiceLabel_ = this.infoData.invoiceLabel;
                            await this.updateInvoice(['amt', 'recVer']);
                            this.infoData.invoiceLabel = invoiceLabel_;
                            done();
                        }).catch((err) => {
                            // eslint-disable-next-line no-console
                            console.error(err);
                            this.$message({
                                type: 'error',
                                message: '切换失败!'
                            });
                            // 将监听到的旧值赋给点击的值
                            this.infoData.invoiceLabel = this.oldInvoiceLabel;
                        }).finally(() => {
                            instance.confirmButtonText = '确定';
                            instance.confirmButtonLoading = false;
                            instance.cancelButtonLoading = false;
                        });
                    } else {
                        instance.confirmButtonText = '确定';
                        instance.confirmButtonLoading = false;
                        instance.cancelButtonLoading = false;
                        done();
                    }
                }
            }).then(() => {
                this.$emit('invoiceLabelChange', this.infoData.invoiceLabel);
                this.$message({
                    type: 'success',
                    message: '切换成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消切换'
                });
                // 将监听到的旧值赋给点击的值
                this.infoData.invoiceLabel = this.oldInvoiceLabel;
            });
        },
        // 监视发票头的编辑状态
        editStatusListener(type) {
            const activeFnMap = {
                'init': () => {
                    if (!this.infoData.sysInvoiceNo) {
                        // 新增的
                        this.editStatus = '2';
                        setEditRecord('header', true);
                    } else {
                        this.editStatus = '0';
                        setEditRecord('header', false);
                    }
                },
                'observe': () => {
                    if (['2', 2].includes(this.editStatus)) return;
                    if (_.isEqual(_.cloneDeep(this.snapshoot), this.infoData)) {
                        setEditRecord('header', false);
                        this.editStatus = '0';
                    } else {
                        setEditRecord('header', true);
                        this.editStatus = '1';
                    }
                }
            };

            activeFnMap[type] && activeFnMap[type]();
        }
    },
    watch: {
        invoiceHeaderData: {
            immediate: true,
            deep: true,
            handler(newValue) {
                Object.assign(this.$data.infoData, this.$options.data().infoData);
                this.infoData = stAi(newValue, this.infoData);
                this.snapshoot = _.cloneDeep(this.infoData);
                this.editStatusListener('init');
            }
        },
        'infoData.invoiceLabel': {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.oldInvoiceLabel = oldValue;
            }
        },
        infoData: {
            deep: true,
            handler(newVal, oldVal) {
                this.editStatusListener('observe');
            }
        }
    },
    async created() {
        const dictCodes = 'BMS_AP_INVOICE_LABEL,SYS_SC_INVOICE_TYPE_BMS,BMS_AP_OPEN_INVOICE_STATUS';
        const { BMS_AP_INVOICE_LABEL_OPTIONS, SYS_SC_INVOICE_TYPE_BMS_OPTIONS } = await getDictAndOptions(dictCodes);
        this.invoiceLabelOptions = BMS_AP_INVOICE_LABEL_OPTIONS;
        this.invoiceTypeOptions = SYS_SC_INVOICE_TYPE_BMS_OPTIONS;
    }
};
</script>

<style lang="less" scoped>
.head-title{
    padding-top: 5px;
    justify-content: space-between;
    .head-t{
        align-items: center;
    }
    .head-right{
        display: flex;
        padding-top: 5px
    }
}

.erow {
    display: flex;

    .left-label,
    .left-value {
        flex: 3;
    }
    .prices-t,
    .prices-b {
        color: #FF8800;
        font-size: 24px;
        margin-top: 38px;
    }
    .texts-t,
    .texts-b {
        font-size: 14px;
        color: #333;
        margin-top: 8px;
    }
    .prices-m {
        color:#000;
        font-size: 14px;
    }
}

    /deep/   .el-input__inner{
        height: 24px;
        line-height: 24px;
    }
    /deep/ .el-input__suffix .el-input__suffix-inner{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: -2px;
    }

</style>